export const feedbackPanelCloseButtonAriaLabel = "ITE2Ce";
export default {feedbackPanelCloseButtonAriaLabel};